import { Directive, Injectable } from '@angular/core';
import { AbstractControl, FormControl, Validator } from '@angular/forms';

@Injectable()
export class PasswordComplexityValidator implements Validator {
  validator: Function;

  constructor() {
    this.validator = PasswordComplexityValidator.passwordComplexityValidatorFactory();
  }

  validate(c: FormControl) {
    return this.validator(c);
  }

  static passwordComplexityValidatorFactory() {
    return (c: AbstractControl) => {
      let strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
      let result = strongRegex.test(c.value);

      return result ? null : { complexityError: true };
    }
  }

}
